import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export type AuthorizedResourceAction = string | { name?: string; description?: string };

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  description?: string | null;
  actions?: AuthorizedResourceAction[];
}

export const getMyAuthorizedResources = (appId: string, options?: ApiRequestOptions) =>
  request<AuthorizedResource[]>('/bff/permission/me/authorized-resources', {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });
